<template>
    <div>
        <div :ref="id"></div>
        <isc-dialog title="插入视频" :visible.sync="dialogFormVisible">
            <input v-if="dialogFormVisible" ref="upload" accept="video/*" type="file" />
            <div slot="footer" class="dialog-footer">
                <isc-button :loading="loading" type="primary" @click="submit">确 认</isc-button>
                <isc-button plain @click="dialogFormVisible = false">取 消</isc-button>
            </div>
        </isc-dialog>
    </div>
</template>
<script>
import { upload as videoUpload } from '@/service/user';
import Editor from '@toast-ui/editor';
import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight';
import hljs from 'highlight.js';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/i18n/zh-cn.js';
import 'highlight.js/styles/github.css';
export default {
    name: 'MarkdownEditor',
    props: {
        value: {
            type: String,
            default: ''
        },

        //预览模式
        isViewer: {
            type: Boolean,
            default: false
        },

        id: {
            type: String,
            required: false,
            default() {
                return 'markdown-editor-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
            }
        },

        //高度
        height: {
            type: String,
            default: '500px'
        },

        //模式
        isHtml: {
            type: Boolean,
            default: false
        },

        //隐藏底部切换
        hideModeSwitch: {
            type: Boolean,
            default: false
        },

        //自定义导航栏功能
        //
        //
        //[{
        //    type: 'button',
        //    options: {
        //          el: () => {
        //                const button = document.createElement('button');
        //                button.className = 'last';
        //                button.innerHTML = `<i>B</i>`;
        //                return button;
        //               },
        //          command: 'Bold',
        //          tooltip: 'Custom Bold'
        //    }
        // }]
        //
        //
        //
        toolbarItems: {
            type: Array,
            default: () => [
                'heading',
                'bold',
                'italic',
                'strike',
                'divider',
                'hr',
                'quote',
                'divider',
                'ul',
                'ol',
                'task',
                'indent',
                'outdent',
                'divider',
                'table',
                'image',
                'link',
                'divider',
                'code',
                'codeblock'
            ]
        },

        //editor配置对象
        options: {
            type: Object,
            default: () => {}
        },

        //防止默认图片转换base64数据过大
        //上传图片至服务器需要return成功后的图片地址
        //
        // (blob) => {
        //   /**上传图片到服务逻辑**/
        //    return imgUrl;  //成功返回图片地址
        // }
        //
        upload: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            dialogFormVisible: false,
            editor: null
        };
    },

    watch: {
        isHtml(val) {
            if (val) {
                this.changeMode('wysiwyg');
            } else {
                this.changeMode('markdown');
            }
        },
        value(val) {
            this.handerCodeChange(val);
        }
    },

    mounted() {
        this.init();
    },

    destroyed() {
        this.editor.off('change');
        this.editor.remove();
    },

    methods: {
        addEvent(name, func) {
            this.editor.eventManager.addEventType(name);
            this.editor.eventManager.listen(name, func);
        },

        insertTool(num, obj) {
            const toolbar = this.editor.getUI().getToolbar();
            toolbar.insertItem(num, obj);
        },
        init() {
            if (!this.isViewer) {
                this.initEditor();
                if (this.isHtml) {
                    this.changeMode('wysiwyg');
                } else {
                    this.changeMode('markdown');
                }
            }
            if (this.isViewer) {
                this.initViewer();
            }
        },
        async submit() {
            this.loading = true;
            let file = this.$refs.upload.files[0];
            console.log(file);
            if (file) {
                let formdata = new FormData();
                formdata.append('file', file);
                formdata.append('type', 'video');
                // let url = file.name;
                let url = await videoUpload(formdata);
                console.log(url);
                this.editor.exec('video', url.urls[0]);
            }
            this.loading = false;
            console.log(this.$refs.upload);
            this.dialogFormVisible = false;
        },
        initEditor() {
            const defaultOpts = {
                el: this.$refs[this.id],
                height: this.height, //高度
                initialEditType: 'markdown', //默认模式 markdown/wysiwyg
                previewStyle: 'vertical', //预览 tab/vertical
                language: 'zh-CN', //语言
                usageStatistics: false,
                hideModeSwitch: this.hideModeSwitch, //隐藏底部md/WYSIWYG模式切换
                toolbarItems: this.toolbarItems, //功能栏
                plugins: [[codeSyntaxHighlight, { hljs }]] //插件
            };
            const opts = Object.assign({}, defaultOpts, this.options);
            this.editor = new Editor(opts);
            let that = this;
            console.log(this.editor);
            /*调用接口方法insertTool增加*/
            this.addEvent('openPopupAddVideo', function () {
                that.dialogFormVisible = true;
            });
            this.insertTool(16, {
                type: 'button',
                options: {
                    className: 'tui-video',
                    event: 'openPopupAddVideo',
                    tooltip: '插入视频',
                    style: 'color:black;'
                }
            });
            this.editor.addCommand('markdown', {
                name: 'video',
                exec(mde, url) {
                    let cm = mde.getEditor();
                    let doc = cm.getDoc();
                    let range = mde.getCurrentRange();
                    let from = {
                        line: range.from.line,
                        ch: range.from.ch
                    };
                    let to = {
                        line: range.to.line,
                        ch: range.to.ch
                    };
                    let replaceText = `<video src="${url}" controls="" width="100%" height="100%" /></video>`;
                    doc.replaceRange(replaceText, from, to, '+addVideo');
                    cm.focus();
                }
            });

            if (this.value) {
                if (this.isHtml) {
                    this.setHtml(this.value);
                } else {
                    this.setMarkdown(this.value);
                }
            }

            this.setEvent();
            this.setImgUpload();
            const wysiwyg = document.getElementsByClassName('wysiwyg');
            wysiwyg[0].innerHTML = '富文本编辑';
        },

        initViewer() {
            const viewer = Editor.factory({
                el: this.$refs[this.id],
                viewer: true,
                initialValue: this.value,
                plugins: [[codeSyntaxHighlight, { hljs }]]
            });
        },

        setEvent() {
            this.editor.on('change', () => {
                if (this.isHtml) {
                    this.$emit('input', this.getHtml());
                } else {
                    this.$emit('input', this.getMarkdown());
                }
            });
        },

        //自定义图片上传
        setImgUpload() {
            this.editor.eventManager.removeEventHandler('addImageBlobHook');
            // 添加自定义监听事件
            this.editor.eventManager.listen('addImageBlobHook', async (blob, callback) => {
                //图片上传
                const url = await this.upload(blob);
                if (url) {
                    callback(url);
                } else {
                    console.log('upload img err');
                }
            });
        },

        setHtml(value) {
            return this.editor.setHtml(value);
        },

        getHtml() {
            return this.editor.getHtml();
        },
        setMarkdown(value) {
            return this.editor.setMarkdown(value);
        },
        getMarkdown() {
            return this.editor.getMarkdown();
        },
        //改变编辑模式 markdown/wysiwyg
        changeMode(type) {
            this.editor.changeMode(type);
        },
        handerCodeChange(newVal) {
            if (this.isHtml) {
                const value = this.getHtml();
                if (newVal !== value) {
                    this.setHtml(newVal);
                }
            } else {
                const value = this.getMarkdown();
                if (newVal !== value) {
                    this.setMarkdown(newVal);
                }
            }
        }
    }
};
</script>
<style>
.tui-editor-contents table th {
    background-color: white;
    color: #222;
    font-weight: 600;
}
.tui-editor-contents h1 {
    border-bottom: 1px solid #dbdbdb;
}
.tui-video {
    background-image: url('../../../src/assets/imgs/video.png');
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: 1px 2px;
}
</style>
